import { UploadOutlined } from '@ant-design/icons';
import { Button, Upload, UploadFile, UploadProps, message } from 'antd';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import useDefaultUploaderProps from '../../hooks/useDefaultUploaderProps';
import Api from '../../services/Api';
import AntdCustomButton from '../buttons/AntdCustomButton';

interface FCProps {
  uploadTextButton: string;
  onChange?: (info: any, previewUrl?: string) => void;
  value?: any;
}

const UploadControl: React.FC<FCProps> = ({
  uploadTextButton,
  onChange,
  value
}) => {
  const [fileList, setFileList] = React.useState<UploadFile[]>([]);

  const { t } = useTranslation();
  const uploadProps = useDefaultUploaderProps();

  const handleChange: UploadProps['onChange'] = (info) => {
    if (
      info.file.status === 'uploading' ||
      info.file.status === 'done' ||
      info.file.status === 'removed'
    ) {
      let newFileList = [...info.fileList];

      // 1. Limit the number of uploaded files
      // Only to show two recent uploaded files, and old ones will be replaced by the new
      newFileList = newFileList.slice(-1);

      // 2. Read from response and show file link
      newFileList = newFileList.map((file) => {
        if (file.response) {
          // Component will show file.url as link
          file.url = file.response.url;
        }
        return file;
      });

      setFileList(newFileList);
    }

    if (info.file.status === 'done') {
      let response = info.file.response;
      onChange &&
        onChange(
          response.__data__.data.data.ObjectURL,
          response.__data__.data.data.PresignedUrl
        );
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} ${t('file upload failed.')}`);
    }
  };

  const props: UploadProps = {
    name: 'file',
    ...uploadProps,
    data: (file) => {
      return {
        name: file.name
      };
    },
    onChange: handleChange
  };

  return (
    <div>
      <Upload {...props} fileList={fileList}>
        <AntdCustomButton icon={<UploadOutlined />} appearance="default">
          {uploadTextButton}
        </AntdCustomButton>

      </Upload>
    </div>
  );
};

export default UploadControl;
